export default {
	active: null,
	selected: [],
	serviceProvider: null,
	vuexModule: "members",
	queryParams: {
		company_id: null,
		assigned: "yes",
	},
	headerColumns: [
		{
			prop: "user",
			keys: ["user.first_name", "user.email"],
			label: "User",
			minWidth: 200,
			searchable: true,
			sortable: true,
			sortBy: "user.first_name",
		},
		{
			prop: "status",
			keys: ["status"],
			label: "Status",
			minWidth: 160,
			sortable: true,
		},
        {
			prop: "cash_call_approver",
			keys: ["cash_call_approver"],
			label: "Cash Call Approver",
			minWidth: 250,
			sortable: true,
		},
        {
			prop: "billing_contact",
			keys: ["billing_contact"],
			label: "Billing Contact",
			minWidth: 210,
			sortable: true,
		},
		{
			prop: "type",
			keys: ["type"],
			label: "Type",
			minWidth: 180,
			searchable: true,
			sortable: true,
		},
		{
			prop: "company_detail_OR_company",
			keys: ["company_detail.name", "company.name"],
			label: "Company",
			minWidth: 180,
			searchable: true,
			sortable: true,
			sortBy: "company.name",
		},
		{
			prop: "report_count",
			label: "Reports",
			minWidth: 170,
			class: "text-center",
			labelClass: "justify-content-center",
			sortable: true,
		},
		{
			prop: "user",
			keys: ["user.date_joined"],
			label: "Date Joined",
			minWidth: 200,
			searchable: true,
			sortable: true,
			sortBy: "user.date_joined",
			searchType: "date",
		},
		{
			prop: "user",
			keys: ["user.last_login"],
			label: "Last Login",
			minWidth: 200,
			searchable: true,
			sortable: true,
			sortBy: "user.last_login",
			searchType: "date",
		},
	],
	filters: {
		assign: [
			{
				value: "yes",
				text: "Assigned",
			},
			{
				value: "no",
				text: "Unassigned",
			},
		],
	},
};
